/**
 * @generated SignedSource<<71910350daaa1bee753f0118d9808860>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedBestsellingDesignsCarouselVariant_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_user">;
  readonly " $fragmentType": "HpSharedBestsellingDesignsCarouselVariant_user";
};
export type HpSharedBestsellingDesignsCarouselVariant_user$key = {
  readonly " $data"?: HpSharedBestsellingDesignsCarouselVariant_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedBestsellingDesignsCarouselVariant_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedBestsellingDesignsCarouselVariant_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarouselModule_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a08761c67f81244f889d5bb88e238e13";

export default node;
